import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ClassicalPlanning = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Classical planning"
    videos={[
      "https://www.youtube.com/embed/un9YB2NuvsI",
      "https://www.youtube.com/embed/9UKAkyNpgDE"
    ]}
    takeaways={[]}
    questions={[
      "An agent in Vellore, India wants to spend his vacation in Paris, France. Plan his trip using hierarchical task network planning. Write the actions with their corresponding preconditions and effects in STRIPS.",
      "The Tower-of-Hanoi puzzle consists of three vertical pegs and several disks of different sizes. Every disk has a hole in the middle, and several disks may be stacked on a peg. The rules allow moving disks from peg to peg, one disk at a time; however, the rules do not allow placing any disk above a smaller one. Initially, all disks are on the leftmost peg in ascending order of size, and the task is to move them to the rightmost peg. Consider the puzzle with three disks, and represent it as a planning problem, using the simple STRIPS language. You should encode the initial state, goal, and operators for moving disks.",
      "A monkey is in a room. Suspended from the ceiling is a bunch of bananas, beyond the monkey's reach. However, in the corner of the room is a box. The ceiling is just the right height so that a monkey climbing on the box could pick the bananas and eat them. The monkey knows how to move around, carry other things around, and reach for the bananas. What is the best sequence of actions for the monkey to reach his goal (banana)? Discuss in detail, the planning representation for the above scenario using the goal stack planning.",
      "Formulate the STRIPS representation for the problem of planning a simple robot's path to move a box from one room to another. Define the initial state, goal state, actions, and the preconditions and effects for each action"
    ]}
    exampleVideos={[]}
  />
);
}

export default ClassicalPlanning;
